// removed by extract-text-webpack-plugin
module.exports = {"icon":"index__icon___1quHO","light":"index__light___18-yi"};


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/Icon/index.css
// module id = 988
// module chunks = 37